export const blockIconsActivitiesScoreboardNew = (
	<span className='material-symbols-outlined'>scoreboard</span>
);
